import React from 'react';

import { SUBSCRIBER_PATH } from '../../../../../constants';
const Dashboard = React.lazy(() => import('..'));

const Routes = {
     path: SUBSCRIBER_PATH.ORGANIZATIONS_DASHBOARD,
     breadcrumb: 'Home',
     element: <Dashboard />,
};

export default Routes;
